export default "__VITE_ASSET__2d1e4002__"